module.exports = __webpack_public_path__ + "static/media/package.4f129b2f.svg";